import React, { useMemo } from "react";
import { Button, Form, Modal, Spinner, Table } from "react-bootstrap";
import SimpleTable from "../../comman/custom-table/SimpleTable";
import CloseBtn from "../CloseBtn";

const ImportCourierModal = ({
  show,
  onHide, // pass the whole editing object or falsey
  importSuccess,
  importReport,
  importing,
  onClose,
  onImport,
  downloadValidationErrorsCsv,
}) => {
  const columns = [
    { header: "Sr.", accessor: "sr", sortable: false },
    { header: "Row", accessor: "row", sortable: true },
    { header: "Errors", accessor: "errors", sortable: false, isActions: false },
    { header: "Data (original)", accessor: "data", sortable: false },
  ];
  const data = useMemo(
    () =>
      importReport?.errors?.map((error, index) => ({
        sr: index + 1,
        row: error.row,
        errors: (
          <ul className="mb-0 ps-3">
            {error.errors?.map((msg, idx) => (
              <li key={idx}>{msg}</li>
            ))}
          </ul>
        ),
        data: (
          <code className="small">{JSON.stringify(error.data, null, 0)}</code>
        ),
      })) || [],
    [importReport?.errors]
  );
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={importSuccess && importReport ? "xl" : "md"}
      centered
      backdrop={importing ? "static" : true}
      keyboard={!importing}
    >
      {!importing && <CloseBtn onClick={onHide} color="#bf352b" />}
      <Modal.Header>
        <Modal.Title>Import Couriers from Excel</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {importing ? (
          <div className="text-center my-4">
            <Spinner animation="border" role="status" />
            <div className="mt-2">Importing… please wait</div>
          </div>
        ) : (
          <>
            {importSuccess === null && (
              <Form.Group className="mb-3" controlId="xlsx_upload">
                <Form.Label>Select .xlsx/.xls file</Form.Label>
                <Form.Control
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={onImport}
                />
                <div className="text-muted small">
                  Ensure the file matches required headers. Upsert will use your
                  backend’s unique key (e.g., short_name or name).
                </div>
              </Form.Group>
            )}

            {importSuccess === true && importReport && (
              <div className="d-grid columns-2 columns-md-4 gap-3">
                <div className="p-2 border rounded text-center bg-light">
                  <strong>Total:</strong> {importReport?.totalRows ?? 0}
                </div>
                <div className="p-2 border rounded text-center bg-light">
                  <strong>Created:</strong> {importReport?.createdCount ?? 0}
                </div>
                <div className="p-2 border rounded text-center bg-light">
                  <strong>Updated:</strong> {importReport?.updatedCount ?? 0}
                </div>
                <div className="p-2 border rounded text-center bg-light">
                  <strong>Errors:</strong> {importReport?.errorCount ?? 0}
                </div>
              </div>
            )}

            {importSuccess === false && importReport && (
              <>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">
                    {(importReport?.createdCount ?? 0) +
                      (importReport?.updatedCount ?? 0) >
                    0
                      ? "Imported with errors"
                      : "Validation Errors"}
                  </h6>
                  {importReport?.errors?.length > 0 && (
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => downloadValidationErrorsCsv(importReport)}
                    >
                      Download errors (.csv)
                    </Button>
                  )}
                </div>

                {/* <Table bordered responsive size="sm">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Row</th>
                      <th>Errors</th>
                      <th>Data (original)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importReport?.errors?.map((error, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{error.row}</td>
                        <td>
                          <ul className="mb-0 ps-3">
                            {error.errors?.map((msg, idx) => (
                              <li key={idx}>{msg}</li>
                            ))}
                          </ul>
                        </td>
                        <td>
                          <code className="small">
                            {JSON.stringify(error.data, null, 0)}
                          </code>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table> */}
                <SimpleTable
                  data={data}
                  columns={columns}
                  loading={false}
                  emptyMessage="No errors found"
                />
              </>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        {importing ? (
          <Button variant="secondary" disabled>
            <Spinner animation="border" size="sm" className="me-2" />
            Importing…
          </Button>
        ) : importSuccess === null ? (
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        ) : (
          <Button variant="outline-secondary" onClick={onClose}>
            Done
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ImportCourierModal;
